import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useContent } from "../../context/ContentContext";
import { Reveal } from "./Reveal";
import { SectionBg } from "./SectionBg";

export const Association = () => {
  const { content } = useContent();
  const a = content.association;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="association" ref={ref} className="relative overflow-hidden bg-[#050505] py-24 md:py-40 border-t border-white/10" data-testid="association-section">
      <SectionBg id="association" />
      <div className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        {a.imageEnabled !== false && (
          <div className="lg:col-span-5">
            <div className="relative lg:sticky lg:top-28 overflow-hidden rounded-lg h-[60vh] lg:h-[80vh]">
              <motion.img style={{ y, scale: 1.15 }} src={a.image} alt="L'association Karams Studio" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-[#050505]/30" />
              {a.imageCaptionEnabled !== false && a.imageCaption && (
                <div className="absolute bottom-6 left-6 text-[10px] tracking-[0.3em] uppercase text-secondary2" data-testid="association-caption">{a.imageCaption}</div>
              )}
            </div>
          </div>
        )}

        <div className={`${a.imageEnabled !== false ? "lg:col-span-7" : "lg:col-span-12"} flex flex-col justify-center`}>
          <Reveal className="mb-14">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-electric" />
              <span className="text-xs tracking-[0.35em] uppercase text-electric">{a.eyebrow}</span>
            </div>
            <h2 className="font-serif text-4xl md:text-6xl text-white leading-[1.05] tracking-tight">
              <span className="float-left font-serif text-8xl md:text-9xl leading-[0.7] text-electric mr-4 mt-2">{a.headline.charAt(0)}</span>
              {a.headline.slice(1)}
            </h2>
          </Reveal>

          <div className="space-y-10">
            {a.chapters.map((c, i) => (
              <Reveal key={i} delay={i * 0.1} className="border-t border-white/10 pt-8">
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl text-white mb-3">{c.title}</h3>
                  <p className="text-sm md:text-base text-secondary2 font-light leading-relaxed max-w-xl">{c.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
